import antdSA from 'antd/lib/locale-provider/fr_FR';
import saMessages from '../locales/fr_FR.json';
import d3frCA from 'd3-format/locale/fr-CA';

import 'moment/locale/fr.js';
import 'numeral/locales/fr-ca.js';

const saLang = {
  messages: {
    ...saMessages
  },
  antd: antdSA,
  locale: 'fr-FR',
  moment: 'fr-ca',
  numeral: 'fr-ca',
  defaultLocale: 'en',
  d3: d3frCA,
  label: 'Français',
  app: 'fr'
};
export default saLang;
